<template>
  <div class="w-100 position-relative pt-2 text-left">
    <b-row
      v-for="(status, idx) in statuses"
      :key="status"
      class="d-flex align-items-center"
      :class="{
        'text-info': complete(status),
        'text-muted': !complete(status),
      }"
      style="z-index: 4;"
    >
      <b-col cols="auto" style="z-index: 10;">
        <div
          :class="{
            'bg-secondary': !complete(idx),
            'bg-primary': complete(idx),
          }"
          style="width: 0.5em; height: 0.5em; border-radius: 50%;"
        ></div>
      </b-col>
      <b-col cols="auto" class="text-dark" style="font-size: smaller;">
        {{ status | capitalize() }}
      </b-col>
      <b-col col class="text-right" style="font-size: smaller;">
        <b-icon
          :icon="complete(idx) ? 'clock-fill' : 'clock'"
          :class="{
            'text-muted': !complete(idx),
            'text-dark': complete(idx),
          }"
        ></b-icon>
         <!-- v-b-tooltip.hover.left
          title="2020-07-30 15:00:00" -->
      </b-col>
    </b-row>
    <div
      class="position-absolute"
      style="bottom: 11px; left: 4px; width: 1px; height: calc(100% - 30px); background: #c9c9c9;"
    >
      <div
        class="position-absolute bg-primary"
        style="top: 0; width: 1px;"
        :style="{ height: `${progress}%` }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShipmentStatusProgress',
  props: ['currentStatus'],
  data() {
    return {
      statusesTypes: [
        { value: 'booked', text: 'Booked' },
        { value: 'pickup', text: 'Pickup' },
        { value: 'toload', text: 'Warehouse' },
        { value: 'todeliver', text: 'Shipping' },
        { value: 'delivered', text: 'Delivered' },
      ],
      statuses: [
        'Booked',
        // 'Processing',
        'Pickup',
        'Warehouse',
        'Shipping',
        'Delivered',
      ],
    };
  },
  computed: {
    progress() {
      return (this.completeIdx / (this.statuses.length - 1)) * 100;
    },
    completeIdx() {
      if (!this.currentStatus) {
        return -1;
      }
      let i = -1;
      for (i = 0; i < this.statuses.length; i += 1) {
        if (this.statusesTypes[i].value === this.currentStatus) {
          break;
        }
      }
      return i === this.statuses.length ? 0 : i;
    },
  },
  methods: {
    complete(idx) {
      return idx <= this.completeIdx;
    },
  },
  filters: {
    capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
  },
};
</script>

<style scoped>
.bg-active {
  background: var(--hover-color);
}

.bg-idle {
  background: var(--accent-color);
}
</style>
